import React, { useCallback, useRef, useState } from "react";

import { useSelector } from "react-redux";

import {
    getLeadZohoAuthUrl,
    sendZohoCodeToService,
} from "helpers/leads/zoho/getAccesToken";

import LoginButton from "../molecules/LoginButton";
import SwalAlertComp from "../SwalAlert";

const ZOHO_PARAM_NAMES = ["code", "location", "accounts-server"];

const ZohoComponent = ({
    name,
    destinationSelectionCode,
    onStoreSuccess,
    disabled = false,
    isReconnect = false,
    onReconnect,
    buttonText,
    isLoadingExternal = false,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const isStoreRequestPending = useRef(false);
    const language = useSelector((state) => state.languagesState.languages);

    const dataTransform = useCallback(
        (params) => ({
            code: params.code,
            location: params.location,
            accounts_server: params["accounts-server"],
            destination_type_code: destinationSelectionCode ?? "",
            name: name?.trim(),
        }),
        [destinationSelectionCode, name],
    );

    const storeZoho = useCallback(
        async (data) => {
            if (!data || isStoreRequestPending.current) return;
            isStoreRequestPending.current = true;
            setIsLoading(true);

            const response = await sendZohoCodeToService(data);
            setIsLoading(false);

            if (response?.status) {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.success ?? "Success",
                    message:
                        language?.lead?.zoho_authorization_completed ??
                        "Zoho authorization completed",
                    icon: "success",
                    timer: 3000,
                });
                onStoreSuccess?.(response?.data ?? {});
            } else {
                isStoreRequestPending.current = false;
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response?.message ?? "",
                    icon: "error",
                });
            }
        },
        [language, onStoreSuccess],
    );

    const onSuccess = useCallback(
        (data) => (isReconnect ? onReconnect?.(data) : storeZoho(data)),
        [isReconnect, onReconnect, storeZoho],
    );

    const resetLoading = useCallback(() => setIsLoading(false), []);

    return (
        <div className="position-relative overflow-hidden z-1">
            <LoginButton
                code="zoho"
                getAuthUrl={getLeadZohoAuthUrl}
                getAuthUrlResponseTransform={(response) => response?.data?.url}
                paramNames={ZOHO_PARAM_NAMES}
                onSuccess={onSuccess}
                dataTransform={dataTransform}
                onError={resetLoading}
                onAuthUrlError={resetLoading}
                logoSrc="/assets/images/zohoLogo.png"
                logoWidth={60}
                buttonText={
                    buttonText ??
                    language?.lead?.zoho_login ??
                    "Login with Zoho"
                }
                disabled={disabled || isLoading || isLoadingExternal}
                isLoadingExternal={isLoading || isLoadingExternal}
            />
        </div>
    );
};

export default ZohoComponent;
